// analytics.ts
import { analytics } from "contexts/FirebaseAuthContext";
import { logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { initMetaPixel } from '../utils/metaPixel';
import TagManager from "react-gtm-module";
import { getAdsTrackingData } from "utils/adsTracking";
type AnalyticsParams = Record<string, any>;


const LINTRK_CONVERSION_ID = 27394753;

let analyticsUserId: string | null = null;
const analyticsUserProperties: Record<string, any> = {};

/**
 * Set Analytics User ID
 */
export const analyticsSetUser = async (userId: string | null) => {
  try {
    setUserId(analytics, userId || null);
    analyticsUserId = userId;
    if ((window as any).fbq) {
      (window as any).fbq('init', process.env.REACT_APP_META_PIXEL_ID, { external_id: userId || undefined });
    }
  } catch (e) {
    console.error("Failed to set Analytics User ID", e);
  }
};

/**
 * Set User Properties
 */
export const analyticsSetUserProperties = async (
  properties: Record<string, any>
) => {
  try {
    for (const [key, value] of Object.entries(properties)) {
      if (!analyticsUserProperties[key] || analyticsUserProperties[key] !== value) {
        setUserProperties(analytics, { [key]: value });
        analyticsUserProperties[key] = value;
      }
    }
  } catch (error) {
    console.error("Failed to set user properties", error);
  }
};

export const initAnalytics = async () => {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID || '' });
  TagManager.dataLayer({
    dataLayer: {
      event: 'consent_update',
      ad_storage: 'granted',
      analytics_storage: 'granted'
    }
  });
  try {
    await initMetaPixel();
  } catch (error) {
    console.log('facebook events init failed!');
  }
}

/**
 * Log Analytics Event
 */
export const analyticsLog = async (event: string, params?: AnalyticsParams) => {
  try {
    const eventName = "brand_" + event.replace(/[^a-zA-Z0-9_]/g, "_").substring(0, 40);
    const adsTrackingData = await getAdsTrackingData();

    try {
      TagManager.dataLayer({
        dataLayer: {
          event: eventName,
          ...(params ?? {})
        }
      });
    } catch (error) {
      console.error("GTM dataLayer push failed", error);
    }

    try {
      const firebaseParams = {
        ...(adsTrackingData ? {
          ...(adsTrackingData.gclid ? { gclid: adsTrackingData.gclid } : {}),
          ...(adsTrackingData.utm ?? {})
        } : {}),
        ...(params ?? {}),
      }
      logEvent(analytics, eventName, firebaseParams);

    } catch (error) {
      console.error("Firebase Analytics log failed", error);
    }

    try {
      const fbEventParams = {
        ...(adsTrackingData ? {
          ...(adsTrackingData.fbclid ? { fbclid: adsTrackingData.fbclid } : {}),
          ...(adsTrackingData.utm ?? {})
        } : {}),
        ...(params ?? {})
      };
      if ((window as any).fbq) {
        if (eventName !== 'page_view') {
          (window as any).fbq('trackCustom', eventName, fbEventParams);
        }
      } else {
        console.error('Facebook Events web sdk not intitialized!');
      }
    } catch (error) {
      console.error("Facebook Events log failed", error);
    }

  } catch (error) {
    console.error("Firebase Analytics log failed", error);
  }
};

export const lintrkTrack = async () => {
  try {
    (window as any).lintrk('track', { conversion_id: LINTRK_CONVERSION_ID });
  } catch (error) {
    console.error("Lintrk track failed", error);
  }
}